import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        languages: '=',
        ok: '&',
        cancel: '&'
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.cancel()"></button>
        <h2>{{ 'authoringTool.Export to another language' | translate }}</h2>
    </div>
    <div class="modal-body">
        <p class="desc muted">
            {{ 'authoringTool.The content of the chapter is copied to the same chapter of the chosen languages' | translate }}
        </p>
        <ul class="checkboxes">
            <li>
                <label>
                    <input type="checkbox" name="exportLangSelectAll" ng-model="vm.areAllLanguagesSelected"
                        ng-change="vm.toggleAllLanguages()"/>
                    <strong>{{ 'authoringTool.Select all' | translate }}</strong>
                </label>
            </li>
            <li ng-repeat="language in vm.languages">
                <label>
                    <input type="checkbox" name="exportLang" ng-model="language.selected"
                        ng-change="vm.refreshSelectAllState()"/>
                    {{ language.label }}
                </label>
            </li>
        </ul>
    </div>
    <div class="modal-footer">
        <ul class="actions01">
            <li class="primary">
                <button class="btn main" type="button" ng-disabled="!vm.hasSelectedLanguages()" ng-click="vm.ok()">
                    {{ 'general.Continue' | translate }}
                </button>
            </li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
    </div>
    `
})
export default class {
    constructor (lodash) {
        this.lodash = lodash;
        this.areAllLanguagesSelected = false;
    }

    $onInit () {
        this.refreshSelectAllState();
    }

    hasSelectedLanguages () {
        return this.lodash.some(this.languages, language => language.selected === true);
    }

    toggleAllLanguages () {
        this.lodash.forEach(this.languages, language => {
            language.selected = this.areAllLanguagesSelected;
        });
    }

    refreshSelectAllState () {
        this.areAllLanguagesSelected = this.languages.length > 0
            && this.lodash.every(this.languages, language => language.selected === true);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/exportChapter/index.js